import { render, staticRenderFns } from "./btn_config.vue?vue&type=template&id=f9b27bee&"
import script from "./btn_config.vue?vue&type=script&lang=js&"
export * from "./btn_config.vue?vue&type=script&lang=js&"
import style0 from "./btn_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports